import React, { Component } from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import FaceID from './components/WebCam';
import ResetPassword from './components/ResetPassword';
import TwoFactorAuth from './components/TwoFactorAuth';
import OtpScreen from './components/OtpScreen';

class App extends Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter basename="/security">
          <div>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/forgotpassword" component={ForgotPassword} />            
              <Route exact path="/faceid" component={FaceID} />    
              <Route exact path="/otp" component={OtpScreen} />
              <Route exact path="/resetpassword" component={ResetPassword} />
              <Route exact path="/twofactorauth" component={TwoFactorAuth} /> 
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js